{
  "consent.action-accept": "Toestaan",
  "consent.action-reject": "Weigeren",
  "consent.description": "Verleen alleen toestemming als u deze site of app vertrouwt. U hoeft niet alle toestemmingen te accepteren.",
  "consent.privacy-policy-label": "Privacybeleid",
  "consent.remember-label": "Onthoud deze beslissing voor de volgende keer. De toepassing kan geen aanvullende toestemming vragen zonder uw toestemming.",
  "consent.remember-tooltip": "Onthoud mijn beslissing",
  "consent.requested-permissions-label": "De toepassing vraagt toegang tot de volgende toestemmingen:",
  "consent.terms-of-service-label": "Gebruiksvoorwaarden",
  "error.back-button": "Ga terug",
  "error.description": "Er is een fout opgetreden met de volgende melding:",
  "error.support-email-link": "Als het probleem aanhoudt, neem dan contact op met <a>{contactSupportEmail}</a>",
  "error.title": "Er is een fout opgetreden",
  "error.title-internal-server-error": "Interne serverfout",
  "error.title-not-found": "404 - Pagina niet gevonden",
  "identities.messages.1010001": "Aanmelden",
  "identities.messages.1010002": "Aanmelden met {provider}",
  "identities.messages.1010003": "Bevestig deze actie door te verifiëren dat u het bent.",
  "identities.messages.1010004": "Voltooi alstublieft de tweede authenticatie-uitdaging.",
  "identities.messages.1010005": "Verifiëren",
  "identities.messages.1010006": "Verificatiecode",
  "identities.messages.1010007": "Back-up herstelcode",
  "identities.messages.1010008": "Ga verder met hardware-sleutel",
  "identities.messages.1010009": "Doorgaan",
  "identities.messages.1010010": "Doorgaan",
  "identities.messages.1010011": "Doorgaan met beveiligingssleutel",
  "identities.messages.1010012": "Bereid uw WebAuthn-apparaat voor (bijv. beveiligingssleutel, biometrische scanner, ...) en druk op doorgaan.",
  "identities.messages.1010013": "Doorgaan",
  "identities.messages.1010014": "Er is een e-mail met een code verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het adres en probeer opnieuw in te loggen.",
  "identities.messages.1010015": "Aanmelden met code",
  "identities.messages.1040001": "Registreren",
  "identities.messages.1040002": "Registreren met {provider}",
  "identities.messages.1040003": "Doorgaan",
  "identities.messages.1040004": "Registreren met beveiligingssleutel",
  "identities.messages.1040005": "Er is een e-mail met een code verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het adres en probeer opnieuw te registreren.",
  "identities.messages.1040006": "Registreren met code",
  "identities.messages.1050001": "Uw wijzigingen zijn opgeslagen!",
  "identities.messages.1050002": "Koppelen aan {provider}",
  "identities.messages.1050003": "Ontkoppelen van {provider}",
  "identities.messages.1050004": "Ontkoppelen van TOTP Authenticator-app",
  "identities.messages.1050005": "QR-code voor Authenticator-app",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Toon back-up herstelcodes",
  "identities.messages.1050008": "Nieuwe back-up herstelcodes genereren",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Dit zijn uw back-up herstelcodes. Bewaar ze op een veilige plaats!",
  "identities.messages.1050011": "Bevestig back-up herstelcodes",
  "identities.messages.1050012": "Beveiligingssleutel toevoegen",
  "identities.messages.1050013": "Naam van de beveiligingssleutel",
  "identities.messages.1050014": "<del>Gebruikt</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Deze methode uitschakelen",
  "identities.messages.1050017": "Dit is uw geheime Authenticator-app. Gebruik het als u de QR-code niet kunt scannen.",
  "identities.messages.1050018": "Beveiligingssleutel verwijderen \"{display_name}\"",
  "identities.messages.1060001": "U heeft met succes uw account hersteld. Wijzig alstublieft uw wachtwoord of stel een alternatieve aanmeldingsmethode in (bijv. sociale aanmelding) binnen de komende {privileged_session_expires_at_unix_until_minutes} minuten.",
  "identities.messages.1060002": "Er is een e-mail met een herstelkoppeling verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat u het e-mailadres gebruikt waarmee u zich heeft geregistreerd.",
  "identities.messages.1060003": "Er is een e-mail met een herstelcode verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat u het e-mailadres gebruikt waarmee u zich heeft geregistreerd.",
  "identities.messages.1070001": "Wachtwoord",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Opslaan",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Verzenden",
  "identities.messages.1070006": "Verificatiecode controleren",
  "identities.messages.1070007": "E-mail",
  "identities.messages.1070008": "Code opnieuw verzenden",
  "identities.messages.1070009": "Doorgaan",
  "identities.messages.1070010": "Herstelcode",
  "identities.messages.1070011": "Verificatiecode",
  "identities.messages.1070012": "Registratiecode",
  "identities.messages.1070013": "Aanmeldingscode",
  "identities.messages.1080001": "Er is een e-mail met een verificatielink naar het opgegeven e-mailadres gestuurd. Als je geen e-mail hebt ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat je het e-mailadres hebt gebruikt waarmee je hebt geregistreerd.",
  "identities.messages.1080002": "Je hebt succesvol je e-mailadres geverifieerd.",
  "identities.messages.1080003": "Er is een e-mail met een verificatiecode naar het opgegeven e-mailadres gestuurd. Als je geen e-mail hebt ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat je het e-mailadres hebt gebruikt waarmee je hebt geregistreerd.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Eigenschap {property} ontbreekt.",
  "identities.messages.4000003": "lengte moet >= {min_length} zijn, maar is {actual_length}",
  "identities.messages.4000004": "komt niet overeen met patroon \"{pattern}\"",
  "identities.messages.4000005": "Het wachtwoord kan niet worden gebruikt vanwege {reason}.",
  "identities.messages.4000006": "De verstrekte referenties zijn ongeldig, controleer op typefouten in je wachtwoord of gebruikersnaam, e-mailadres of telefoonnummer.",
  "identities.messages.4000007": "Er bestaat al een account met dezelfde identificatiegegevens (e-mail, telefoon, gebruikersnaam, ...).",
  "identities.messages.4000008": "De verstrekte verificatiecode is ongeldig, probeer het opnieuw.",
  "identities.messages.4000009": "Kon geen aanmeldingsidentificatoren vinden. Ben je ze vergeten in te stellen? Dit kan ook worden veroorzaakt door een servermisconfiguratie.",
  "identities.messages.4000010": "Account nog niet actief. Ben je vergeten je e-mailadres te verifiëren?",
  "identities.messages.4000011": "Je hebt geen TOTP-apparaat ingesteld.",
  "identities.messages.4000012": "Deze herstelcode is al gebruikt.",
  "identities.messages.4000013": "Je hebt geen WebAuthn-apparaat ingesteld.",
  "identities.messages.4000014": "Je hebt geen herstelcodes ingesteld.",
  "identities.messages.4000015": "Dit account bestaat niet of heeft geen beveiligingssleutel ingesteld.",
  "identities.messages.4000016": "De herstelcode is niet geldig.",
  "identities.messages.4000017": "lengte moet <= {max_length} zijn, maar is {actual_length}",
  "identities.messages.4000018": "moet >= {minimum} zijn, maar is {actual}",
  "identities.messages.4000019": "moet > {minimum} zijn, maar is {actual}",
  "identities.messages.4000020": "moet <= {maximum} zijn, maar is {actual}",
  "identities.messages.4000021": "moet < {maximum} zijn, maar is {actual}",
  "identities.messages.4000022": "{actual} is geen veelvoud van {base}",
  "identities.messages.4000023": "maximaal {max_items} items toegestaan, maar er zijn {actual_items} items gevonden",
  "identities.messages.4000024": "minimaal {min_items} items toegestaan, maar er zijn {actual_items} items gevonden",
  "identities.messages.4000025": "items op index {index_a} en {index_b} zijn gelijk",
  "identities.messages.4000026": "verwacht {allowed_types_list}, maar kreeg {actual_type}",
  "identities.messages.4000027": "Er bestaat al een account met dezelfde identificatiegegevens (e-mail, telefoon, gebruikersnaam, ...). Meld je aan bij je bestaande account en koppel je sociale profiel in de instellingenpagina.",
  "identities.messages.4000028": "Je hebt geprobeerd in te loggen met {credential_identifier_hint}, dat al wordt gebruikt door een ander account. Je kunt inloggen met {available_credential_types_list}. Je kunt inloggen met een van de volgende sociale aanmeldingsproviders: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "moet gelijk zijn aan constante {expected}",
  "identities.messages.4000030": "constante mislukt",
  "identities.messages.4000031": "Het wachtwoord kan niet worden gebruikt omdat het te veel lijkt op de identificatiegegevens.",
  "identities.messages.4000032": "Het wachtwoord moet minstens {min_length} tekens lang zijn, maar is {actual_length}.",
  "identities.messages.4000033": "Het wachtwoord mag hoogstens {max_length} tekens lang zijn, maar is {actual_length}.",
  "identities.messages.4000034": "Het wachtwoord is gevonden in datalekken en mag niet langer worden gebruikt.",
  "identities.messages.4000035": "Dit account bestaat niet of heeft geen aanmelding met code ingesteld.",
  "identities.messages.4000036": "De verstrekte kenmerken komen niet overeen met de eerder geassocieerde kenmerken met deze stroom.",
  "identities.messages.4010001": "De aanmeldingsstroom is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4010002": "Kon geen strategie vinden om mee in te loggen. Heb je het formulier correct ingevuld?",
  "identities.messages.4010003": "Kon geen strategie vinden om je mee aan te melden. Heb je het formulier correct ingevuld?",
  "identities.messages.4010004": "Kon geen strategie vinden om je instellingen bij te werken. Heb je het formulier correct ingevuld?",
  "identities.messages.4010005": "Kon geen strategie vinden om je account mee te herstellen. Heb je het formulier correct ingevuld?",
  "identities.messages.4010006": "Kon geen strategie vinden om je account mee te verifiëren. Heb je het formulier correct ingevuld?",
  "identities.messages.4010007": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4010008": "De aanmeldingscode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.4040001": "De registratie flowis verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4040002": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4040003": "De registratiecode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.4050001": "De instellingen flow is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4060001": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4060002": "De herstel flow heeft een fout bereikt en moet opnieuw worden geprobeerd.",
  "identities.messages.4060004": "De hersteltoken is ongeldig of is al gebruikt. Probeer de flow opnieuw.",
  "identities.messages.4060005": "De herstel flow is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4060006": "De herstelcode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.4070001": "De verificatietoken is ongeldig of is al gebruikt. Probeer de flow opnieuw.",
  "identities.messages.4070002": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4070003": "De verificatie flow heeft een fout bereikt en moet opnieuw worden geprobeerd.",
  "identities.messages.4070005": "De verificatie flow is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4070006": "De verificatiecode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Wachtwoord vergeten?",
  "login.logged-in-as-label": "Je bent ingelogd als:",
  "login.logout-button": "Uitloggen",
  "login.logout-label": "Er is iets mis?",
  "login.registration-button": "Registreren",
  "login.registration-label": "Heb je nog geen account?",
  "login.subtitle-oauth2": "Om te authenticeren bij {clientName}",
  "login.title": "Inloggen",
  "login.title-aal2": "Tweefactorauthenticatie",
  "login.subtitle-aal2": "Kies een manier om uw tweefactorauthenticatie te voltooien",
  "login.code.subtitle": "Er wordt een verificatiecode per e-mail verzonden",
  "login.webauthn.subtitle": "Bereid uw WebAuthN-apparaat voor",
  "login.totp.subtitle": "Voer de code in die door uw Authenticator-app is gegenereerd",
  "login.lookup_secret.subtitle": "Voer een van uw 8-cijferige back-up herstelcodes in",
  "login.title-refresh": "Bevestig dat jij het bent",
  "login.2fa.go-back": "Werkt er iets niet?",
  "login.2fa.go-back.link": "Ga terug",
  "login.2fa.method.go-back": "Kies een andere methode",
  "logout.accept-button": "Ja",
  "logout.reject-button": "Nee",
  "logout.title": "Wil je uitloggen?",
  "recovery.login-button": "Inloggen",
  "recovery.login-label": "Herinner je je inloggegevens?",
  "recovery.title": "Herstel je account",
  "registration.login-button": "Inloggen",
  "registration.login-label": "Heb je al een account?",
  "registration.subtitle-oauth2": "Om te authenticeren bij {clientName}",
  "registration.title": "Registreer een account",
  "settings.navigation-back-button": "Ga terug",
  "settings.navigation-backup-codes": "2FA Backupcodes",
  "settings.navigation-logout": "Uitloggen",
  "settings.navigation-oidc": "Sociaal Inloggen",
  "settings.navigation-password": "Wachtwoord",
  "settings.navigation-profile": "Profiel",
  "settings.navigation-totp": "Authenticator App",
  "settings.navigation-webauthn": "Hardware Tokens",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Hier kun je instellingen beheren die verband houden met je account. Houd er rekening mee dat bepaalde acties vereisen dat je opnieuw wordt geauthenticeerd.",
  "settings.title": "Accountinstellingen",
  "verification.registration-button": "Registreren",
  "verification.registration-label": "Heb je nog geen account?",
  "verification.title": "Verifieer je account",
  "verification.back-button": "Ga terug",
  "two-step.code.description": "Een verificatiecode wordt naar uw e-mail gestuurd",
  "two-step.code.title": "E-mailcode",
  "two-step.passkey.description": "Gebruik de vingerafdruk- of gezichtsherkenning van uw apparaat",
  "two-step.passkey.title": "Toegangscode (aanbevolen)",
  "two-step.password.description": "Voer uw wachtwoord in dat is gekoppeld aan uw account",
  "two-step.password.title": "Wachtwoord",
  "two-step.webauthn.title": "Beveiligingssleutel",
  "two-step.webauthn.description": "Gebruik uw beveiligingssleutel om te verifiëren",
  "two-step.totp.title": "Gebruik uw Authenticator-app (TOTP)",
  "two-step.totp.description": "Gebruik een 6-cijferige eenmalige code van uw authenticator-app",
  "two-step.lookup_secret.title": "Herstelcode",
  "two-step.lookup_secret.description": "Gebruik een van uw 8-cijferige back-upcodes om te authenticeren",
  "identities.messages.1010023": "",
  "identities.messages.1070014": "",
  "identities.messages.1070015": "",
  "identities.messages.4000038": "",
  "login.cancel-button": "",
  "login.cancel-label": "",
  "identities.messages.1010016": "",
  "identities.messages.1010017": "",
  "identities.messages.1010018": "",
  "identities.messages.1010019": "",
  "identities.messages.1010020": "",
  "identities.messages.1010021": "",
  "identities.messages.1010022": "",
  "identities.messages.1040007": "",
  "identities.messages.1040008": "",
  "identities.messages.1040009": "",
  "identities.messages.1050019": "",
  "identities.messages.1050020": "",
  "identities.messages.4000037": "",
  "identities.messages.4010009": "",
  "identities.messages.4010010": "",
  "input.placeholder": "",
  "card.header.description.login": "",
  "card.header.description.registration": "",
  "card.header.parts.code": "een code die naar je is verzonden",
  "card.header.parts.totp": "je authenticator-app",
  "card.header.parts.lookup_secret": "een backup herstelcode",
  "card.header.parts.identifier-first": "",
  "card.header.parts.oidc": "",
  "card.header.parts.passkey": "",
  "card.header.parts.password.login": "",
  "card.header.parts.password.registration": "",
  "card.header.parts.webauthn": "",
  "forms.label.forgot-password": "",
  "login.subtitle": "",
  "login.subtitle-refresh": "",
  "misc.or": "",
  "recovery.subtitle": "",
  "registration.subtitle": "",
  "settings.subtitle": "",
  "verification.subtitle": "",
  "settings.totp.info.linked": "U heeft momenteel een authenticator-app verbonden.",
  "settings.totp.info.not-linked": "Om te activeren, scan de QR-code met je authenticator en voer de code in.",
  "settings.totp.title": "",
  "settings.totp.description": "Voeg een TOTP Authenticator App toe aan uw account om de beveiliging van uw account te verbeteren. Populaire Authenticator Apps zijn LastPass en Google Authenticator.",
  "settings.lookup_secret.description": "",
  "settings.lookup_secret.title": "",
  "settings.navigation.title": "",
  "settings.oidc.description": "",
  "settings.oidc.info": "",
  "settings.oidc.title": "",
  "settings.passkey.description": "",
  "settings.passkey.info": "",
  "settings.passkey.title": "",
  "settings.password.description": "",
  "settings.password.title": "",
  "settings.profile.description": "",
  "settings.profile.title": "",
  "settings.title-lookup-secret": "",
  "settings.title-navigation": "",
  "settings.title-oidc": "",
  "settings.title-passkey": "",
  "settings.title-password": "",
  "settings.title-profile": "",
  "settings.title-totp": "",
  "settings.title-webauthn": "",
  "settings.webauthn.description": "",
  "settings.webauthn.info": "",
  "settings.webauthn.title": "",
  "card.footer.select-another-method": "",
  "account-linking.title": "",
  "property.code": "",
  "property.email": "",
  "property.identifier": "",
  "property.password": "",
  "property.phone": "",
  "property.username": "",
  "consent.title": "Autoriseren {party}",
  "consent.subtitle": "Een derde partij applicatie wil toegang tot informatie die aan uw account {identifier} is gekoppeld.",
  "consent.scope.openid.title": "Identiteit",
  "consent.scope.openid.description": "Stelt de applicatie in staat uw identiteit te verifiëren. Dit is vereist voor authenticatie en een betrouwbare inlogervaring.",
  "consent.scope.offline_access.title": "Offline toegang",
  "consent.scope.offline_access.description": "Stelt deze applicatie in staat u ingelogd te houden, zelfs wanneer u deze niet actief gebruikt.",
  "consent.scope.profile.title": "Profielinformatie",
  "consent.scope.profile.description": "Geeft toegang tot uw basisprofielgegevens, inclusief uw gebruikersnaam, voornaam en achternaam.",
  "consent.scope.email.title": "E-mailadres",
  "consent.scope.email.description": "Haal uw e-mailadres en de verificatiestatus ervan op.",
  "consent.scope.address.title": "Fysiek adres",
  "consent.scope.address.description": "Toegang tot uw postadres.",
  "consent.scope.phone.title": "Telefoonnummer",
  "consent.scope.phone.description": "Haal uw telefoonnummer en de verificatiestatus ervan op.",
  "error.action.go-back": "",
  "error.footer.copy": "",
  "error.footer.text": "",
  "error.title.what-can-i-do": "",
  "error.title.what-happened": "",
  "error.instructions": ""
}
